"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Subscriber_1 = require("rxjs/Subscriber");
var rxemitter_1 = require("./rxemitter");
var ToRxEmitterOperator = (function () {
    function ToRxEmitterOperator(eventObj) {
        this.eventObj = eventObj;
    }
    ToRxEmitterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ToRxEmitterSubscriber(subscriber, this.eventObj));
    };
    return ToRxEmitterOperator;
}());
exports.ToRxEmitterOperator = ToRxEmitterOperator;
var ToRxEmitterSubscriber = (function (_super) {
    __extends(ToRxEmitterSubscriber, _super);
    function ToRxEmitterSubscriber(destination, eventObj) {
        var _this = _super.call(this, destination) || this;
        _this.eventObj = eventObj;
        _this.count = 0;
        return _this;
    }
    ToRxEmitterSubscriber.prototype._next = function (x) {
        var _this = this;
        var result;
        if (this.eventObj.map)
            result = this.eventObj.map.call(null, x, this.count++);
        else
            result = x;
        if (this.eventObj.timeout)
            setTimeout(function () { return rxemitter_1.RxEmitter.emit(_this.eventObj.eventName, result); }, this.eventObj.timeout);
        else
            rxemitter_1.RxEmitter.emit(this.eventObj.eventName, result);
        this.destination.next(x);
    };
    return ToRxEmitterSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=torxemitteroperator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxemitter/torxemitteroperator.js
// module id = 1314
// module chunks = 0